import { render, staticRenderFns } from "./MainDriverDetails.vue?vue&type=template&id=4a429438&"
import script from "./MainDriverDetails.vue?vue&type=script&lang=js&"
export * from "./MainDriverDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports